/**
 * Personal preferences of the current user, one document per
 * (user, workspace, object) scope. Mirrors compozz-common/dto/UserPreferences.go.
 * Preferences never alter shared model data: they only customize how the
 * current user sees it (sidebar view folders).
 */
export interface UserPreferences {
    _key?: string;
    userKey: string;
    workspaceKey: string;
    objectKey: string;
    // Folder paths ("Commercial/Rapports/2025"); array position = sibling
    // display order. Ancestors always present (the backend normalizes).
    viewFolders?: string[] | null;
    // folder path -> ordered view keys: the list order is the personal display
    // order inside the folder (the shared View.order only rules the root).
    // A view held by no list shows at the root; a key lives in one list only.
    viewsByFolder?: Record<string, string[]> | null;
}

export const FOLDER_SEPARATOR = "/";
export const MAX_FOLDER_DEPTH = 5;
